const nf2 = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const nf0 = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });

export const fmt = (v) => (v == null || isNaN(v) ? "—" : nf2.format(v));
export const fmtInt = (v) => (v == null || isNaN(v) ? "—" : nf0.format(v));
export const inr = (v) => (v == null || isNaN(v) ? "—" : `₹${nf2.format(v)}`);
export const signed = (v) => (v == null || isNaN(v) ? "—" : `${v > 0 ? "+" : ""}${nf2.format(v)}`);
export const pct = (v) => (v == null || isNaN(v) ? "—" : `${v > 0 ? "+" : ""}${Number(v).toFixed(2)}%`);
export const tone = (v) => (v > 0 ? "text-up" : v < 0 ? "text-down" : "text-muted-foreground");

export function compact(v) {
  if (v == null || isNaN(v)) return "—";
  const a = Math.abs(v);
  if (a >= 1e7) return `${(v / 1e7).toFixed(2)}Cr`;
  if (a >= 1e5) return `${(v / 1e5).toFixed(2)}L`;
  if (a >= 1e3) return `${(v / 1e3).toFixed(1)}K`;
  return nf0.format(v);
}

export function istTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour12: false });
}

export function istDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", hour12: false, day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", second: "2-digit" });
}

export function displayName(inst, key) {
  if (!inst) return key?.split("|")[1] || key;
  return inst.trading_symbol;
}

export const isDerivative = (inst) => ["FUT", "CE", "PE"].includes(inst?.instrument_type);
